import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import { ActEventTransformer } from '@/transformers/ActEvent';
import { FieldOptionTransformer } from "@/transformers/FieldOptionTransformer";
var requests = require("@/utils/requests").default;
import moment from "moment";
export default {
  data: function data() {
    return {
      event_options: {
        filters: {}
      },
      projectStatusList: [],
      newEventOriginal: {},
      allParticipants: [],
      eventStatus: [],
      allParticipantsKey: 'new'
    };
  },
  computed: {
    events: {
      get: function get() {
        return this.$store.state.activities.events;
      },
      set: function set(val) {
        this.$store.state.activities.events = val;
      }
    }
  },
  methods: {
    deleteEvent: function deleteEvent(id) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new KivaProxy({
                endpoint: 'act/event'
              }).destroy(id).then(function (response) {
                _this.listAll();
                _this.$store.state.lastUpdate = {
                  app: 'act',
                  model: 'event',
                  id: record_id,
                  work: "delete",
                  time: moment(),
                  data: item
                };
                _this.$message({
                  type: "success",
                  message: _this.$t("Delete completed")
                });
              }).catch(function () {
                _this.$message({
                  type: "info",
                  message: _this.$t("Delete failed")
                });
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getEventStatus: function getEventStatus() {
      var _this2 = this;
      new KivaProxy({
        endpoint: "act/event/event_status/options"
      }).all().then(function (response) {
        _this2.eventStatus = FieldOptionTransformer.fetchCollection(response.records);
      });
    },
    getProjectStatusList: function getProjectStatusList() {
      var _this3 = this;
      new KivaProxy({
        endpoint: "act/project/project_status/options"
      }).all().then(function (notes) {
        _this3.projectStatusList = notes.records;
      });
    },
    findStatusColor: function findStatusColor(event) {
      return event.relatedData && event.relatedData.project_status ? event.relatedData.project_status.color : "000";
    },
    getDate: function getDate(date) {
      if (date) {
        var diff = moment().diff(moment(date), "minutes");
        if (diff > -1 && diff < 2) {
          return "Now";
        } else if (diff > -1 && diff < 60) {
          return diff + " mins. ago";
        } else if (diff > 60 && diff < 1440) {
          var ndiff = Math.round(diff / 60);
          return ndiff + " hours ago";
        } else if (diff >= 1440) {
          return this.format_date(date) + " " + this.format_time(date);
        }
      }
      return "";
    },
    removeSelectedEvent: function removeSelectedEvent(event, method, record) {
      this.focus = false;
      if (method == 'create' && record && record[0]) {
        this.getEventById(record[0].record_id);
      } else if (method == 'update') {
        this.newEventTrigger = {};
        this.newEventOriginal.subject = event.subject;
        this.newEventOriginal.activityNotes = event.activityNotes;
        this.newEventOriginal.projectStatus = event.projectStatus;
        this.newEventOriginal.date = event.date;
        this.newEventOriginal.startTime = event.startTime;
        this.newEventOriginal.endTime = event.endTime;
        this.newEventKey = "up" + Math.random(1, 99999);
        this.newEventListKey = "m" + Math.random(1, 99999);
      } else {
        this.newEventOriginal.subject = '';
        this.newEventOriginal.recordId = '';
        this.newEventTrigger = {};
        this.allParticipants = [];
        this.newEventKey = "m" + Math.random(1, 99999);
        this.newEventListKey = "m" + Math.random(1, 99999);
      }

      // this.$emit("listAll",true)
    },
    uploadAttachment: function uploadAttachment(id, files) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var total, all, say;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(files && files[0] && files[0].name)) {
                _context3.next = 12;
                break;
              }
              total = files.length;
              all = Object.keys(files);
              say = 1;
              _context3.prev = 4;
              _context3.next = 7;
              return all.forEach( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(key) {
                  var f, fd, rtn;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        f = files[key];
                        fd = new FormData();
                        fd.append("file", f.raw, f.name);
                        fd.append("record_id", id);
                        fd.append("attachment_id", "");
                        _context2.next = 7;
                        return requests.upload_attachments({
                          files: fd,
                          record_id: id,
                          app: 'act',
                          model: 'event'
                        });
                      case 7:
                        rtn = _context2.sent;
                      case 8:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 7:
              _context3.next = 12;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](4);
              console.log("Error act 145");
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[4, 9]]);
      }))();
    },
    saveEvent: function saveEvent(data) {
      var _arguments = arguments,
        _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var showNotify, event, participants, tasks, milestoneDate, item, method;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              showNotify = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : true;
              event = data.event ? data.event : data;
              participants = data.participants;
              tasks = data.tasks;
              milestoneDate = data.milestoneDate; // if(!event.subject){
              //   return false
              // } 
              if (!event) {
                event = _this4.selectedEvent;
              }
              _this4.loading = true;
              item = ActEventTransformer.send(event);
              method = event ? event.recordId && event.recordId != "0" ? 'update' : 'create' : '';
              if (method) {
                new KivaProxy({
                  endpoint: 'act/event'
                })[method](item).then( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(response) {
                    var _record_id, its, ids, project_status, projectData, formatUser, _method;
                    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          _this4.loading = false;
                          if (!response.success) {
                            _context4.next = 30;
                            break;
                          }
                          _record_id = response.records[0].record_id;
                          if (!(data.files && data.files[0])) {
                            _context4.next = 6;
                            break;
                          }
                          _context4.next = 6;
                          return _this4.uploadAttachment(_record_id, data.files);
                        case 6:
                          its = [];
                          if (!tasks) {
                            _context4.next = 12;
                            break;
                          }
                          ids = _this4.tasks.map(function (k) {
                            return k.record_id;
                          });
                          if (!ids.join(",")) {
                            _context4.next = 12;
                            break;
                          }
                          _context4.next = 12;
                          return new KivaProxy({
                            endpoint: 'act/task/' + ids.join(",")
                          }).submit('patch', 'act/task/' + ids.join(","), {
                            'record': {
                              event: _record_id
                            }
                          }).then(function (response) {});
                        case 12:
                          project_status = event.projectStatus ? event.projectStatus.value ? event.projectStatus.value : event.projectStatus : '';
                          if (!(item.calendar == 6 && project_status)) {
                            _context4.next = 18;
                            break;
                          }
                          projectData = {
                            record_id: event.project.value,
                            project_status: project_status
                          };
                          new KivaProxy({
                            endpoint: 'act/project'
                          })['update'](projectData).then(function (response) {
                            var projects = _this4.$store.state.project.projects.find(function (k) {
                              return k.record_id == projectData.record_id;
                            });
                            if (projects && projects.project_status) {
                              projects.project_status.value = event.projectStatus ? event.projectStatus.value : null;
                              projects.project_status.label = event.projectStatus ? event.projectStatus.label : null;
                            }
                          });
                          _context4.next = 24;
                          break;
                        case 18:
                          if (!(item.calendar == 1 || item.calendar == 2 || item.calendar == 4 || item.calendar == 7)) {
                            _context4.next = 24;
                            break;
                          }
                          formatUser = [];
                          if (participants && participants[0]) {
                            participants.forEach(function (element) {
                              var el = element.split("_");
                              formatUser.push({
                                target_app_id: el[0],
                                target_model_id: el[1],
                                target_record_id: parseInt(el[2]),
                                target_email: el[3],
                                target_name: el[4]
                              });
                            });
                          }
                          _context4.next = 23;
                          return new KivaProxy({
                            endpoint: '/act/event/' + _record_id + '/participant'
                          }).submit('get', '/act/event/' + _record_id + '/participant').then(function (response) {
                            var checkParticipants = response.data;
                            if (checkParticipants && checkParticipants[0]) {
                              checkParticipants.forEach(function (cp) {
                                var name = formatUser.find(function (fu) {
                                  return fu.target_app_id == cp.target_app_id && fu.target_model_id == cp.target_model_id && fu.target_record_id == cp.target_record_id;
                                });
                                if (!name) {
                                  new KivaProxy({
                                    endpoint: '/act/event/' + _record_id + '/participant/' + cp.participant_id
                                  }).submit('delete', '/act/event/' + _record_id + '/participant/' + cp.participant_id);
                                }
                              });
                            }
                          });
                        case 23:
                          if (formatUser && formatUser[0]) {
                            new KivaProxy({
                              endpoint: 'act/event/' + _record_id + '/participant'
                            }).submit('post', 'act/event/' + _record_id + '/participant', {
                              'records': formatUser
                            }).then(function (response_participant) {}).catch(function (err) {
                              console.log("err", err);
                            });
                          }
                        case 24:
                          if (milestoneDate) {
                            _method = event ? event.event && event.event.record_id && event.event.record_id != "0" ? 'update' : 'create' : '';
                            new KivaProxy({
                              endpoint: 'act/milestone'
                            })[_method]({
                              record_id: null,
                              due_date: milestoneDate,
                              subject: item.subject,
                              event: _record_id,
                              project: item.project
                            }).then(function (response) {}).catch(function (err) {
                              console.log("err", err);
                            });
                          }
                          _this4.removeSelectedEvent(event, method, response.records);
                          if (data.refresh && data.refresh == 'no') {} else {
                            _this4.$store.state.lastUpdate = {
                              app: 'act',
                              model: 'event',
                              id: _record_id,
                              work: "create",
                              time: moment().valueOf(),
                              data: item
                            };
                            _this4.$store.state.lastUpdate.time = moment().valueOf();
                            _this4.id = _record_id;
                            if (showNotify) {
                              _this4.$notify({
                                title: _this4.$t("Success"),
                                message: _this4.$t("Successfully saved"),
                                type: "success"
                              });
                            }
                          }
                          if (_this4.dialogFormVisible) {
                            _this4.dialogFormVisible = false;
                          }
                          _context4.next = 31;
                          break;
                        case 30:
                          throw 'Saving failed.';
                        case 31:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4);
                  }));
                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  console.log(err);
                  _this4.loading = false;
                  _this4.$notify({
                    title: _this4.$t('Error'),
                    message: err,
                    type: 'error'
                  });
                });
              } else {
                _this4.loading = false;
                _this4.$notify({
                  title: _this4.$t('Error'),
                  message: _this4.$t("No data found."),
                  type: 'error'
                });
              }
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    eventFields: function eventFields() {
      return ['activity_status', 'start_date', 'end_date', 'subject', 'activity_notes', 'location', 'project', 'project_status', 'accountName', 'event_status', "pages", 'calendar', 'record_owner', 'deal', 'description', 'created_on', 'created_by', 'last_modified_on', 'last_modified_by', 'cfd_project_status__color', 'cfd_project_status__label'];
    },
    getEventById: function getEventById(id) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this5.getParticipants(id);
              new KivaProxy({
                endpoint: 'act/event'
              }).setFields(_this5.eventFields()).find(id).then(function (response) {
                _this5.loading = false;
                var newEvent = ActEventTransformer.fetchCollection([_objectSpread({}, response.record)]);
                var events = _this5.$store.state.activities.events;
                events.unshift(newEvent[0]);
                // this.$store.state.events.events = this.events;
                _this5.newEventKey = "m" + Math.random(1, 99999);
                _this5.newEventListKey = "m" + Math.random(1, 99999);
              }).catch(function (err) {
                _this5.loading = false;
              });
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getParticipants: function getParticipants(id) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              new KivaProxy({
                endpoint: '/act/event/' + id + '/participant'
              }).submit('get', '/act/event/' + id + '/participant').then(function (response) {
                _this6.allParticipantsKey = id;
                _this6.allParticipants = response.data;
              }).catch(function (err) {
                _this6.loading = false;
              });
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getList: function getList(options) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var filters;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this7.loading = true;
              filters = {}; // if (options.filters.calendar) {
              //   filters.calendar = options.filters.calendar
              // }
              if (options.filters.project) {
                filters.project = ["=", options.filters.project];
              }
              if (options.filters.account) {
                filters.account_name = ["=", options.filters.account];
              }
              new KivaProxy({
                endpoint: 'act/event'
              }).setFilters(filters).setFields(_this7.eventFields()).setSort("start_date").setDir("DESC").all().then(function (response) {
                _this7.loading = false;
                _this7.$store.state.activities.events = ActEventTransformer.fetchCollection(response.records);
                // this.$store.state.events.events = this.events;
                _this7.newEventKey = "m" + Math.random(1, 99999);
              }).catch(function (err) {
                _this7.loading = false;
              });
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    }
  }
};